export const isLastStep = (current, steps) => current === steps.length - 1
export const isNotFirstStep = (current) => current > 0
export const isDeliveryStep = (current) => current === 1